import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* istanbul ignore file */
import React, { Suspense, useState, useEffect } from 'react';
import LoadingIndicator from '../LoadingIndicator';
import { useAppSelector } from '../../hooks/useAppSelector';
import Adyen from '../Adyen/Adyen';
import { configSelector } from '../../redux/ConfigState/ConfigState.selectors';
import { sendRioEvent, SpecType, SubType, SharedCommandNames, StatusTypes } from '@chegg/commerce-utils';
import { sendRioEventCallback, doFireStatusUpdate } from '../../utils/CallbackUtils';
import { getString } from '../../constants/Strings';
import { Processors } from '../../constants/AppConstants';
import { Component } from '../../constants/CallbackConstants';
var InitializeAdyen = function InitializeAdyen(_) {
  var config = useAppSelector(configSelector);
  var paymentProcessors = config.paymentProcessors;
  var isAdyenEnabled = paymentProcessors.indexOf(Processors.ADYEN) > -1;
  var rioNamespace = config.rioNamespace;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    service = _useState2[0],
    setService = _useState2[1];
  useEffect(function () {
    if (!service) return;
    /* istanbul ignore next */
    sendRioEvent({
      info: getString('APP.RIO.EVENTS.EL_NAME.PM_LOADED'),
      specType: SpecType.COMPONENT_VIEW,
      subType: SubType.COMPONENT,
      callback: sendRioEventCallback,
      namespace: rioNamespace,
      force: false
    });
  }, [service]);
  var callback = function callback(adyenService) {
    setService(adyenService);
    doFireStatusUpdate([{
      status: StatusTypes.SUCCESS,
      command: SharedCommandNames.INITIALIZE,
      payload: {
        component: Component.PAYMENT_OPTIONS
      }
    }]);
  };
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(LoadingIndicator, null)
  }, isAdyenEnabled && /*#__PURE__*/React.createElement(Adyen, {
    callback: callback
  }));
};
export default /*#__PURE__*/React.memo(InitializeAdyen);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/InitializeAdyen/index.js
// module id = 4601
// module chunks = 11